import { takeLatest, call, put, select } from 'redux-saga/effects';
import axios from 'axios';
import { registrationRequest, registrationSuccess, registrationFailure } from '../reducers/login';
import { xapiRequest } from '../reducers/xapi';
import { API_LINK } from '../../constants';
import * as moment from 'moment';
const API = `${API_LINK}api/register`;

function* registrationFunctionAxios() {
 
  const state = yield select(fullState => fullState);
  console.log('REGISTERNOW',state);
  const {
    email,
    password,
    firstname,
    lastname,
    programCode,
    AmLeader,
    telephone,
    birthdate,
    gender,
    employeeNo,
    race,
    language,
    identityNo,
    conIdentificationTypeID,
    conTitleID,
    maidenName,
    disability,
    maritalStatus,
    conSocioEconomicStatus,
    conCountryID,
    conRegion,
    conBranch,
    conProvinceID,
    residenceStatus,
    driversLicence,
    positionHeld,
    highestQualification,
    highestSchoolLevel,
    qualificationDetail,
    cell,
    fax,
    socc,
    address,
    city,
    code,
    businessUnit,
    noYears,
  } = state.form.registration.values;
  
  const amLeader =  0;
  const dob = moment(state.form.registration.values.birthdate).format('YYYY-MM-DD')
  
  const response = yield call(() => {

    console.log('conCountryID:', conCountryID[0]);
    console.log('conIdentificationTypeID:', conIdentificationTypeID[0]);
    console.log('conProvinceID:', conProvinceID[0]);
    console.log('conTitleID:', conTitleID[0]);
    console.log('conDisabilityStatusID:', disability[0]);
    console.log('driversLicence:', driversLicence[0]);
    console.log('gender:', gender[0]);
    console.log('highestQualification:', highestQualification[0]);
    console.log('highestSchoolLevel:', highestSchoolLevel[0]);
    console.log('conLanguageID:', language[0]);
    console.log('maritalStatus:', maritalStatus[0]);
    console.log('race:', race[0]);
    console.log('residenceStatus:', residenceStatus[0]);
    console.log('socc:', socc[0]);
    return axios({
      method: 'post',
      url: API,
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      credentials: 'same-origin',
      data: {
        conCountryID: conCountryID[0],
        conIdentificationTypeID: conIdentificationTypeID[0],
        conProvinceID: conProvinceID[0],
        conClientRegionID: conRegion[0],
        conClientBranchID: conBranch[0],
        conTitleID: conTitleID[0],
        conDisabilityStatusID: disability[0],
        driversLicense: driversLicence[0],
        gender: gender[0],
        highestQualification: highestQualification[0],
        highestSchoolLevel: highestSchoolLevel[0],
        conLanguageID: language[0],
        maritalStatus: maritalStatus[0],
        race: race[0],
        residenceStatus: residenceStatus[0],
        conSocioEconomicStatusID:  conSocioEconomicStatus[0],
        socc: socc[0],
        firstname: firstname,
        lastname: lastname,
        email: email,
        telephone: telephone,
        password: password,
        programCode: programCode,
        amLeader: amLeader,
        employeeNo: employeeNo !== null ? employeeNo : '',
        birthdate: dob,
        maidenName: maidenName !== null ? maidenName : '',
        identityNo: identityNo,
        positionHeld: positionHeld !== null ? positionHeld : '',
        qualificationDetail: qualificationDetail !== null ? qualificationDetail : '',
        cell: cell,
        fax: fax,
        address: address,
        city: city,
        code: code,
        businessUnit: businessUnit !== null ? businessUnit : '',
        noYears: noYears !== null ? noYears : '',
      },
    });
  });
  console.log('REGISTER2',response);
  return response;
}

function* workerRegistrationSaga() {
  try {
    const response = yield call(registrationFunctionAxios);
    const responseFromLogin = response.data;

    if (response.status === 200) {
      yield put(registrationSuccess(responseFromLogin));
      yield put(xapiRequest({ xapiType: 'registration' }));
    }

    if (response.status === 205) {
      yield put(registrationFailure('Email does not exist'));
    }
    if (response.status === 206) {
      yield put(registrationFailure(response.data));
    }
    if (response.status === 208) {
      yield put(registrationFailure(response.data));
    }
    if (response.status === 500) {
      yield put(registrationFailure(response.statusText));
    }
  } catch (error) {
    console.log('REGISTERERROR',error.message);
    yield put(registrationFailure(error.error));
  }
}

export function* watcherRegistrationSaga() {
  yield takeLatest(registrationRequest().type, workerRegistrationSaga);
}



// WEBPACK FOOTER //
// ./src/redux/sagas/post_registration.js